import { Component, Input, OnInit, ViewChild, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ApiService } from "src/app/api.service";
import { DatetimePipe } from "src/app/pipes";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-asset-notes",
	templateUrl: "./asset-notes.component.html",
	styleUrls: ["./asset-notes.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [FormsModule, ActionButtonComponent, DatetimePipe]
})
export class AssetNotesComponent implements OnInit {
	private api = inject(ApiService);

	@Input()
	asset: APIResults.Asset;

	@ViewChild("addNotePanel") addNotePanel: any;

	public adminLogs: any[];
	public newLog: any = {};

	async ngOnInit(): Promise<void> {
		await this.RefreshLogs();
	}

	public async RefreshLogs() {
		this.adminLogs = undefined;
		const logs = await this.api.GetAdminLogs(this.asset.asset_id);
		for (const log of logs) {
			log.editTitle = log.title;
			log.editContent = log.content;
		}
		this.adminLogs = logs;
	}

	public async SaveLog(log: any) {
		if (log.admin_log_id) {
			// Existing, update
			await this.api.UpdateAdminLog(log.admin_log_id, log.editTitle, log.editContent);
		} else {
			await this.api.CreateAdminLog(this.asset.asset_id, log.editTitle, log.editContent);
		}
		this.newLog = {};
		this.addNotePanel.nativeElement.classList.add('collapsed');
		await this.RefreshLogs();
	}

	public async DeleteLog(admin_log_id: number) {
		await this.api.DeleteAdminLog(admin_log_id);
		await this.RefreshLogs();
	}
}
